import photo from '../img/AdobeStock_739503508.png';
import Section from '../components/section/Section';
import Card from '../components/card/Card';

export default function Home() {
    return (
      <>
        <div className="content">
            <Section color={"pink"}>
                <div className="col-xs-12 col-sm-6">
                    <div class="section-split-image"></div>
                </div>
                <div className="col-xs-12 col-sm-6">
                    <div className="box">
                        <h1 className="margin-bottom-20">Home title</h1>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                            Etiam pretium posuere sem eget rutrum. 
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                            Quisque nibh enim, malesuada sed elementum sed, sollicitudin dapibus mi. 
                            Sed fringilla sapien tortor, in sollicitudin nulla vulputate eu. 
                            Aliquam quis faucibus elit, sed commodo velit. Ut in odio a arcu fermentum faucibus. 
                            Nam ut libero ultricies, pulvinar libero eget, commodo neque.</p>
                    </div>
                </div>
            </Section>
            <Section>
                <div className="col-xs-12 col-sm-6">
                    <div className="box text-left">
                        <h2 className="margin-bottom-20">Ben jij</h2>
                        <p>Op zoek naar een fit, gezond en stressbestendig leven? Ik coach op orthomoleculair gebied, voeding en lifestyle. 
                            Zo help ik je de balans te vinden tussen feiten en voelen. 
                            Samen gaan we op zoek naar de oorzaak van de klachten en geef ik inzicht in het systeem en het onstaan van de disbalans. 
                            Je verkrijgt zo grip op jouw gezondheid.</p>
                        <h2 className="margin-bottom-20 margin-top-40">Waar kan ik je mee helpen?</h2>
                        <ul>
                            <li>Weinig energie</li>
                            <li>Vermoeidheid</li>
                            <li>Hormonale klachen</li>
                            <li>Lukt het niet om af te vallen</li>
                            <li>Prikkelbaar</li>
                            <li>Migraine en hoofdpijn</li>
                            <li>Slecht slapen</li>
                            <li>Slechte huid</li>
                            <li>Vruchtbaarheidsproblemen</li>
                            <li>(bijna) iedere chronische en vage klacht...</li>
                        </ul>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-6">
                    <div className="box">
                        <img src={photo} alt="nutrition" />
                    </div>
                </div>
            </Section>
            <Section color={'green'}>
                <div className="col-xs-12">
                    <div className="box">
                        <h2 className="margin-bottom-20">Mijn werkwijze</h2>
                        <p>Nulla vehicula turpis ut dolor finibus mollis. Suspendisse ut sem ex. Aenean non nulla turpis. Nunc sodales urna neque. Nam nec nisl quis urna faucibus scelerisque vehicula a eros. Integer aliquam nec turpis a dapibus. Etiam iaculis facilisis cursus. Aenean pellentesque semper enim, nec viverra leo. Cras commodo massa at commodo malesuada. Nam consequat id urna non gravida. Ut efficitur sapien id diam gravida molestie. Nunc malesuada augue dui, eget tempor nibh posuere eu.</p>
                    </div>
                </div>
            </Section>
        </div>
      </>
    );
  }